type Open = (clipId: string) => void;
let open: Open | null = null;
export function connectImageActions(handler: Open) {
  open = handler;
  return () => {
    if (open === handler) open = null;
  };
}
export function openImageActions(clipId: string) {
  if (!open) throw Error("편집기 준비 후 다시 시도해 주세요.");
  open(clipId);
}
